import { selectionErrors } from './selection.ts';
export type CandidateActionResult<T> =
	| { data: T; error: null }
	| { data: null; error: string; code?: string };

export function candidateActionResult<T>(
	response: { status: number; data: T | null; error: unknown },
	fallback: string,
): CandidateActionResult<T> {
	if (response.status < 400 && !response.error && response.data != null)
		return { data: response.data, error: null };
	const code =
		typeof response.error === 'object' &&
		response.error !== null &&
		'message' in response.error &&
		typeof response.error.message === 'string' &&
		Object.hasOwn(selectionErrors, response.error.message)
			? response.error.message
			: undefined;
	if (code) return { data: null, error: selectionErrors[code], code };
	let message = fallback;
	if (response.status === 401)
		message = 'Войдите в аккаунт заново и обновите страницу интервью.';
	else if (response.status === 403)
		message = 'У вашего аккаунта нет доступа к этому интервью.';
	else if (response.status === 409)
		message = 'Состояние интервью изменилось. Обновите страницу.';
	else if (
		response.status === 400 &&
		typeof response.error === 'object' &&
		response.error !== null &&
		'message' in response.error
	) {
		if (response.error.message === 'ai_interview_language_not_supported')
			message =
				'У задач интервью нет общего поддерживаемого языка. Обратитесь к куратору.';
		if (response.error.message === 'ai_interview_language_required')
			message =
				'Для старта интервью требуется язык программирования. Обратитесь к куратору.';
	}
	return { data: null, error: message };
}

// Unwrap only on the client, after the serializable result crosses the action boundary.
export function unwrapCandidateResult<T>(result: CandidateActionResult<T>): T {
	if (result.error !== null) throw new Error(result.error);
	return result.data;
}
